export default __webpack_public_path__ + "static/media/target.d6f73f52.svg";